import type { ApiKeyScope, WebhookEventType } from '@wave/shared';

/**
 * Человекочитаемые подписи справочников публичного API — единый источник для всех
 * компонентов интеграции (модалка ключа, вкладки журнала и документации). Вынесены
 * из ApiKeyModal.tsx, чтобы не тянуть модалку ради двух словарей.
 */

/** Человекочитаемые подписи скоупов ключа (см. API_KEY_SCOPES в shared). */
export const SCOPE_LABELS: Record<ApiKeyScope, string> = {
  'orders:create': 'Создание заявок',
  'orders:read': 'Чтение заявок',
  'orders:confirm': 'Подтверждение проводок',
  'refs:read': 'Справочники',
};

/** Подписи типов событий вебхука (см. WEBHOOK_EVENT_TYPES в shared). */
export const WEBHOOK_EVENT_LABELS: Record<WebhookEventType, string> = {
  'order.status.changed': 'Смена статуса заявки',
  'order.provodka.confirmed': 'Подтверждение проводки',
};
